import React from 'react';
import './refund.css';
import INCSUBCommonHeading from '../../commonComponents/commonHeading/commonHeading';
import INCSUBFooter from '../../components/Footer/Footer';

function INCRefund() {
  return (
    <div className='INCSUTermsAndConditions_ctn'>
      <div className='INCSUTermsAndConditions_ctn_content'>
        <div className='INCSUTermsAndConditions_ctn_content_div'>
          <div className='INCSUTermsAndConditions_ctn_content_div_first' style={{ width: '100%', boxSizing: 'border-box' }}>
            
            <INCSUBCommonHeading text={'Refund Policy & Disclaimer'} height={0} top={4} left={64} />

            <div className='INCSUTermsAndConditions_ctn_content_div_first_head' style={{ color: '#fff', fontSize: '28px', fontWeight: '700', marginTop: '20px', marginBottom: '5px' }}>
              Refund Policy
            </div>

            <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>
              Last Updated: 29/5/26
            </div>

            <p className='INCSUTermsAndConditions_ctn_content_div_first_para' style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px', lineHeight: '1.6', marginBottom: '30px' }}>
              TheSubscription is committed to providing a reliable and fair experience for both Hosts and Members. This policy explains when refunds may be granted and how refund requests are handled.
            </p>

            {/* 1. Eligibility for Refund */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                1. Eligibility for Refund
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                Refunds may be approved in the following situations:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0 0 12px 0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Access is not delivered within the timeline specified by the Host.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Invalid, incorrect, or non-working credentials are provided.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Access is revoked due to Host misconduct or violation of platform policies.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  A duplicate payment occurs due to a technical issue.
                </li>
              </ul>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                Once reported, TheSubscription will review the issue and work with the Host to resolve it. If the issue remains unresolved, an eligible refund may be issued.
              </p>
            </div>

            {/* 2. Refund Processing Time */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                2. Refund Processing Time
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                If a refund is approved, please allow 5–7 business days for the amount to be processed and reflected in your original payment method or account balance, where applicable.
              </p>
            </div>

            {/* 3. Payment Processing */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                3. Payment Processing
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  All payments on TheSubscription are processed through authorized third-party payment service providers.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription does not directly process, store, or handle sensitive payment credentials such as card numbers, UPI PINs, banking passwords, or authentication details.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Refunds, where approved, will be processed through the same payment channel used during the original transaction or through the user's account balance, where applicable.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Any delays caused by banks, payment gateways, or financial institutions are outside the control of TheSubscription.
                </li>
              </ul>
            </div>

            {/* 4. Non-Refundable Scenarios */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                4. Non-Refundable Scenarios
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                Refunds are generally not applicable in the following cases:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Access has been successfully delivered and used.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  The Member voluntarily leaves a pool after receiving access.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  The Member violates platform policies or pool rules.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Service interruptions result from actions taken by the third-party subscription provider.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  The refund request is submitted without sufficient information for verification.
                </li>
              </ul>
            </div>

            {/* 5. How to Raise a Refund Request */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                5. How to Raise a Refund Request
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                Members can raise a refund request through the platform's support system or by contacting our support team.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                Please provide accurate details and supporting evidence, such as screenshots or error messages, to help us review the request efficiently.
              </p>
            </div>

            {/* 6. Cancellation Policy */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                6. Cancellation Policy
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                Members may cancel participation only before access has been delivered.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                Once access has been successfully provided, cancellation requests will be reviewed under this Refund Policy.
              </p>
            </div>

            {/* 7. Final Note (Refund Policy) */}
            <div style={{ width: '100%', marginBottom: '40px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                7. Final Note
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                TheSubscription operates as a digital marketplace connecting Hosts and Members.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                Refund requests are reviewed individually, and decisions are made based on available evidence, transaction records, and platform activity.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                By using TheSubscription, you agree to this policy.
              </p>
            </div>

            {/* Section Divider */}
            <hr style={{ border: '0', borderTop: '1px solid rgba(255, 255, 255, 0.1)', margin: '40px 0' }} />

            {/* Platform & Brand Disclaimer */}
            <div className='INCSUTermsAndConditions_ctn_content_div_first_head' style={{ color: '#fff', fontSize: '28px', fontWeight: '700', marginTop: '20px', marginBottom: '5px' }}>
              Platform & Brand Disclaimer
            </div>

            <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>
              Last Updated: 29/5/26
            </div>

            <p className='INCSUTermsAndConditions_ctn_content_div_first_para' style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px', lineHeight: '1.6', marginBottom: '30px' }}>
              This disclaimer explains TheSubscription's relationship with third-party brands, platforms, and subscription services referenced on the platform.
            </p>

            {/* Disclaimer 1. Brand Ownership & Usage */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                1. Brand Ownership & Usage
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  All brand names, logos, trademarks, and service marks displayed on TheSubscription are the property of their respective owners.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  They are used strictly for identification and reference purposes only.
                </li>
              </ul>
            </div>

            {/* Disclaimer 2. No Affiliation or Endorsement */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                2. No Affiliation or Endorsement
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription is not affiliated with, endorsed by, sponsored by, or officially connected with any third-party brand, platform, or service provider.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Any reference to platforms such as Netflix, Spotify, YouTube Premium, Disney+, Amazon Prime, Microsoft, or similar services is made solely for descriptive purposes.
                </li>
              </ul>
            </div>

            {/* Disclaimer 3. Nature of the Platform */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                3. Nature of the Platform
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription operates as a digital marketplace connecting users who have unused seats available in legally purchased multi-user subscription plans with users seeking access to those plans.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription does not own, purchase, sell, resell, distribute, or provide subscriptions.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  The platform only facilitates transactions and communication between independent users.
                </li>
              </ul>
            </div>

            {/* Disclaimer 4. Third-Party Platforms */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                4. Third-Party Platforms
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Use of any third-party subscription service is governed by that service provider's own terms, policies, and guidelines.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Users are solely responsible for ensuring their participation complies with the requirements of the respective platform.
                </li>
              </ul>
            </div>

            {/* Disclaimer 5. Important Notice */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                5. Important Notice
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription only allows listings based on legally obtained multi-user plans that support simultaneous access by multiple users.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Unauthorized, cracked, trial, or illegally obtained access is strictly prohibited.
                </li>
              </ul>
            </div>

            {/* Disclaimer 6. Final Note */}
            <div style={{ width: '100%', marginBottom: '40px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                6. Final Note
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Brand names and logos are used for identification purposes only.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription is not affiliated with or endorsed by any third-party brand, platform, or subscription provider.
                </li>
              </ul>
            </div>

            {/* Section Divider */}
            <hr style={{ border: '0', borderTop: '1px solid rgba(255, 255, 255, 0.1)', margin: '40px 0' }} />

            {/* Closing & Support Contact Details */}
            <div style={{ width: '100%', marginBottom: '40px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                Contact & Support
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                For assistance or policy inquiries, please contact our support team at:
              </p>
              <p style={{ color: '#fff', fontSize: '16px', fontWeight: '500', marginBottom: '20px' }}>
                📧 <a href="mailto:support@thesubscription.in" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'underline' }}>support@thesubscription.in</a>
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px', fontWeight: '600', margin: '0' }}>
                Thank you for using TheSubscription.
              </p>
            </div>

          </div>
        </div>
      </div>
      <INCSUBFooter />
    </div>
  );
}

export default INCRefund;
